export default {
  sampleImage: {
    id: 'product_jp_product_condition_card_sample',
    defaultMessage: 'Sample image',
  },
}
